import React from "react";
import { Navbar } from "../../components/user-components/NavigationBar/Navbar";
import { AboutHead } from "../../components/user-components/Header/AboutHead";
import { Aboutme } from "../../components/user-components/Aboutme/Aboutme";

export const About = () => {
  return (
    <>
      <Navbar />
      <AboutHead />
      <Aboutme />
    </>
  );
};
